const themeActionTypes =  {    
    RETRIEVING_THEMES: "RETRIEVING_THEMES",
    RETRIEVED_THEMES: "RETRIEVED_THEMES",
    ERROR_RETRIEVING_THEMES: "ERROR_RETRIEVING_THEMES",
    RETRIEVING_THEME_FILES: "RETRIEVING_THEME_FILES",
    RETRIEVED_THEME_FILES: "RETRIEVED_THEME_FILES",
    ERROR_RETRIEVING_THEME_FILES: "ERROR_RETRIEVING_THEME_FILES"
};
export default themeActionTypes;
